<ng-container *appTranslate="let t">
  <div class="carousel-container">
    <div class="carousel-wrapper">
      <!-- Revenue Panel -->
      <div
        class="carousel-panel"
        [class.active]="currentPanelIndex() === 0"
        [class.prev]="prevIndex() === 0"
        [class.next]="nextIndex() === 0"
      >
        <app-kpi-carousel-panel [kpis]="revenueKpis()" titleKey="kpi.section.revenue" icon="pi pi-euro" />
      </div>

      <!-- Accounts Receivable Panel -->
      <div
        class="carousel-panel"
        [class.active]="currentPanelIndex() === 1"
        [class.prev]="prevIndex() === 1"
        [class.next]="nextIndex() === 1"
      >
        <app-kpi-carousel-panel
          [kpis]="accountsReceivableKpis()"
          titleKey="kpi.section.accountsReceivable"
          icon="pi pi-euro"
        />
      </div>

      <!-- Candidates Panel -->
      <div
        class="carousel-panel"
        [class.active]="currentPanelIndex() === 2"
        [class.prev]="prevIndex() === 2"
        [class.next]="nextIndex() === 2"
      >
        <app-kpi-carousel-panel [kpis]="candidateKpis()" titleKey="kpi.section.candidates" icon="pi pi-users" />
      </div>

      <!-- Organizations Panel -->
      <div
        class="carousel-panel"
        [class.active]="currentPanelIndex() === 3"
        [class.prev]="prevIndex() === 3"
        [class.next]="nextIndex() === 3"
      >
        <app-kpi-carousel-panel
          [kpis]="organizationKpis()"
          titleKey="kpi.section.organizations"
          icon="pi pi-building"
        />
      </div>
    </div>
    <div class="carousel-indicators">
      <button
        class="indicator"
        [class.active]="currentPanelIndex() === 0"
        (click)="goToPanel(0)"
        [title]="t('kpi.section.revenue')"
      ></button>
      <button
        class="indicator"
        [class.active]="currentPanelIndex() === 1"
        (click)="goToPanel(1)"
        [title]="t('kpi.section.accountsReceivable')"
      ></button>
      <button
        class="indicator"
        [class.active]="currentPanelIndex() === 2"
        (click)="goToPanel(2)"
        [title]="t('kpi.section.candidates')"
      ></button>
      <button
        class="indicator"
        [class.active]="currentPanelIndex() === 3"
        (click)="goToPanel(3)"
        [title]="t('kpi.section.organizations')"
      ></button>
    </div>
  </div>
</ng-container>
